<mat-card>
  <mat-card-title>
    <p8-layout-settings-header [titlePath]="['Historique de vos demandes en recrutement']" [iconRacine]="'source'"></p8-layout-settings-header>
  </mat-card-title>
  <mat-card-subtitle>
    Cet espace vous permet d'accéder à la liste de vos demandes ou aux demandes dont vous êtes contact et à leur suivi</mat-card-subtitle>
  <mat-card-content fxLayout="column">
    <div style="padding-top: 5px" fxFlexAlign="end">
      <div fxLayout="row">
        <app-export-excel *ngIf="hasDar" fxFlexAlign="end" [owner]="connecte" [tooltip]="'Export Excel de toutes mes demandes'"></app-export-excel>
        <span style="border-left: 2px solid rgb(154, 154, 154); height: 36px; margin-right: 5px; margin-left: 5px;"></span>
        <button color="accent" mat-raised-button (click)="ajouter()" routerLinkActive="true"
              matTooltip="Cliquer pour saisir votre demande">
        <mat-icon>add</mat-icon> NOUVELLE DEMANDE
      </button>
      </div>
    </div>
    <div style="margin-top: 5px;">
      <app-filter-list-dar *ngIf="hasDar"
        (allStatusChange)="onOnOffAllStatutAndFilter($event)"
        (onStatusChange)="onStatusChanged($event)"></app-filter-list-dar>
    </div>
    <div *ngIf="!loadingInProgress && !hasDar"><mark>Vous n'avez pas encore de DAR dans votre espace demandeur, cliquer sur le bouton NOUVELLE DEMANDE pour démarrer votre demande</mark></div>
    <app-data-table
      [dataSource]="dsDossiers"
      [extraParams]="extraParams"
      [refreshButton]="true"
      [refreshIcone]="false"
      [filterDisplay]="true"
      [urlBaseOverride]="urlList"
      [placeHolderFilter]="'Numéro de DAR ou intitulé de poste'"
      [toolTipFilter]="'Recherche de dossiers : par un numéro de DAR ou intitulé de poste'"
      [flexAction]="5" [flexColumn]="90"
      [pageSize]="10" [pageSizesList]="[5,10,25]"
      [columns]="columns" [actions]="actions"
      [showFirstLastButtons]="true"
      [fontSizeCell]="'0.9em'"
      [showLoader]="true"
      [loaderMask]="true"
      [loaderProgress]="false">
    </app-data-table>
    <div *ngIf="isContact">
      <small class="mat-h5"><span [ngClass]="'contact-dar'">&nbsp;&nbsp;&nbsp;&nbsp;</span> DARs pour lesquelles le demandeur vous a mis en copie</small>
    </div>
    <div *ngIf="hasDar && !allStatus" style="text-align: right; margin-top: 10px;">
      <span style="font-style: italic; font-family: Roboto, Arial, sans-serif">Les dossiers en clos et sans suite ne sont pas affichés par défaut</span>
    </div>
  </mat-card-content>
</mat-card>



